import React from 'react'
import cn from 'classnames'
import { Dropdown, DropdownContent, DropdownToggle } from '@mc/design-system'
import HamburgerIcon from './assets/hamburgerIcon.svg'
import classes from './Menu.module.scss'

const Menu = ({
  ariaLabel,
  label,
  className,
  contentClassName,
  children,
  onToggle,
  showBadge,
  dismissBadge,
  placement = 'bottom-end',
}: {
  ariaLabel?: string
  label?: string
  /** Applied to the toggle button. */
  className?: string
  /** Applied to the expanded panel. */
  contentClassName?: string
  children?: React.ReactNode
  onToggle?: () => void
  showBadge?: boolean
  dismissBadge?: () => void
  placement?: React.ComponentProps<typeof Dropdown>['placement']
}) => {
  const handleClick = () => {
    dismissBadge?.()
    onToggle?.()
  }

  return (
    <Dropdown placement={placement} fixed>
      <DropdownToggle>
        <button
          aria-label={ariaLabel}
          className={cn('mc-clickable mc-py-2', className)}
          onClick={handleClick}
          style={{
            transition: 'opacity 200ms ease',
            background: 'none',
            color: 'inherit',
          }}
        >
          <div className='d-flex align-items-center position-relative'>
            {label && (
              <h6 className='mc-text-h6 mc-text--capitalize mc-pr-1 d-none d-lg-block'>
                {label}
              </h6>
            )}
            <HamburgerIcon className='mc-icon mc-icon--3' />
            {showBadge && (
              <div
                className='mc-bg-primary mc-corners--circle position-absolute'
                style={{
                  width: 8,
                  height: 8,
                  top: -4,
                  right: -4,
                }}
              />
            )}
          </div>
        </button>
      </DropdownToggle>
      <DropdownContent
        appendToBody={false}
        className={cn(classes.menu, contentClassName)}
      >
        {children}
      </DropdownContent>
    </Dropdown>
  )
}

export default Menu
